<template>

  <el-row>
    <el-col :span="12" :xs="24" class="m-auto" v-loading="isLoading">

      <el-card>
        <el-row>
          <el-col :span="4">
            <div class="mb-2">
              <img :src='avatarUser' alt="profile" width="100">
            </div>
            <el-button size="small" type="primary" @click="show = true">Trocar</el-button>
            <upload-img field="img"
                        @crop-success="cropSuccess"
                        @crop-upload-success="cropUploadSuccess"
                        @crop-upload-fail="cropUploadFail"
                        v-model="show"
                        :width="100"
                        :height="100"
                        :url="urlUpload"
                        langType="pt-br"
                        :params="params"
                        :headers="headers"
                        img-format="jpg"></upload-img>
          </el-col>
          <el-col :span="18">
            <el-form ref="form" :model="form" label-width="120px">
              <el-form-item label="Nome">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="Apelido">
                <el-input v-model="form.apelido"></el-input>
              </el-form-item>
              <el-form-item label="Função">
                <el-input v-model="form.funcao"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="onReset" type="danger">Cancelar</el-button>
                <el-button type="primary" @click="onSubmit">Salvar</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import {Notification} from 'element-ui'
  import { imgApi } from "../../domain/utils";
  import UploadImg from 'vue-image-crop-upload';

  export default {
    name: "UserProfile",
    components: {
      UploadImg
    },
    data() {
      return {
        isLoading: false,
        form: {},
        show: false,
        params: {name: 'avatar'},
        headers: {},
        imgDataUrl: ''
      }
    },
    computed: {
      ...mapState(['user']),
      ...mapState('Auth', ['access_token']),
      urlUpload() {
        return `${process.env.API_URI_PATH}/user/profile/img`
      },
      avatarUser()
      {
        return imgApi(this.user.foto)
      }
    },
    methods: {
      ...mapActions('User', ['updateProfile']),
      ...mapActions(['refreshProfile']),
      async onSubmit() {
        try {
          this.isLoading = true
          await this.updateProfile({...this.form})
          Notification.success("Profile Atualizado com sucesso.")
        } catch (e) {
          console.log(e)
          Notification.error("Contate do administrador do sistema")
        } finally {
          this.isLoading = false
        }
      },
      onReset() {
        this.form = {...this.user}
      },
      cropSuccess(imgDataUrl, field) {
        this.imgDataUrl = imgDataUrl;
      },
      async cropUploadSuccess(jsonData, field) {
        await this.refreshProfile()
        console.log(jsonData);
        console.log('field: ' + field);
      },
      cropUploadFail(status, field) {
        console.log(status);
        console.log('field: ' + field);
      }

    },
    mounted() {
      this.form = {...this.user}
      this.headers = {
        Authorization: `Bearer ${this.access_token}`
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/User/Profile.vue